'use client'
import { Button } from '@/components/base/Button'
import { E_CONTENT_HORIZONTAL_ALIGNMENT } from '@/schema'
import { downloadPDF } from '@/utils'
import { memo, useCallback } from 'react'
import styled, { css } from 'styled-components'

// PENDING UPDATE WITH PROPER typeCms from schema
type ContentTypeButtonDownload = {
  columnType: 'button_download'
  horizontalAlignment: E_CONTENT_HORIZONTAL_ALIGNMENT
  text: string
  download: string
  downloadFilename: string
}

interface Props {
  data: ContentTypeButtonDownload
}

export const ContentButtonDownload = memo(({ data }: Props) => {
  const { text, download:url, downloadFilename:filename, horizontalAlignment } = data

  const onClick = useCallback(async () => {
    const resBlob = await fetch(url, {
      method: 'GET',
    })

    const data = await resBlob.blob()
    await downloadPDF(data, `${filename}`, null)
  }, [filename, url])

  return (
    <ButtonDownload onClick={onClick} $xAlign={horizontalAlignment} bgColor='--color-text'>
      {text}
    </ButtonDownload>
  )
})

const ButtonDownload = styled(Button)<{ $xAlign: Props['data']['horizontalAlignment']}>`
  ${({ $xAlign }) => $xAlign === E_CONTENT_HORIZONTAL_ALIGNMENT.LEFT ? css`margin-left: 0;` : $xAlign === E_CONTENT_HORIZONTAL_ALIGNMENT.RIGHT ? css`margin-right: 0;` : css`margin: 0 auto;`}
`
